 // Function to populate the page with data globally
 function populatePageWithData(data,resultContainer) {
  const resultsContainer = document.getElementById(resultContainer);
  resultsContainer.innerHTML ="";
  //console.log("result_data", data);

  jsonData = data; // Update the global variable with new data
  updateResultsContainer(resultContainer); // Update the page content
  initializeCheckboxes(); // Initialize checkboxes after updating the content

  // jsonData = data; // Update the global variable with new data
  // updateResultsContainer(); // Update the page content
  // // Check only the first checkbox after updating the page content
  // const checkboxes = document.querySelectorAll('input[type="checkbox"]');
  // checkboxes.forEach((checkbox, index) => {
  //   checkbox.checked = index === 0;
  //   const groupId = checkbox.id.replace('chk', '');
  //   toggleVisibility(groupId);
  // });
}

  // Function to update the results container
  function updateResultsContainer(resultContainer) {
   

    // Extract data from the JSON object
    const Details = jsonData.vehicleDetails;
    const groups = jsonData.groups;

    // Your existing HTML content
    const htmlContent = `
    <div id="dynamicResult">
     ${(Details)?`
      <div class="row d-flex mb-4 pb-4">
        <div class="col-md-8">
          <span class="fs-2 fw-bold lh-1">Results for:</span><br>
          <span class="fs-1 fw-black lh-1">${Details?.make} ${Details?.model} (${Details?.yearMin} - ${Details?.yearMax})</span><br>
        </div>
      </div>`:``}
      ${(groups &&groups.length > 0 && groups.every(group => group.products.length === 0))||!groups ||groups.length==0 ? `
      <p>Can’t find a listing for your vehicle? Please contact Australian Clutch Services and our friendly sales team will check our other available listings under sister brands Xtreme Clutch and ClutchPro.
      </p>
    ` : `
      <div class="row">
        <div class="col-md-3">
          <div class="accordion" id="accordionAll">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingCategory">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCategory" aria-expanded="false" aria-controls="collapseCategory">
                  All Category
                </button>
              </h2>
              <div id="collapseCategory" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionAll">
                <div class="accordion-body">
                  <ul class="list-group">
                    <li class="list-group-item">
                      <input class="form-check-input border-warning me-3 mt-1" type="checkbox" id="chkAll" checked>
                      All
                    </li>
                    ${groups.filter(group => group.products && group.products.length > 0).map(group => `
                    <li class="list-group-item">
                      <input class="form-check-input border-warning me-3 mt-1" type="checkbox" value="" id="chk${group.id}" checked>
                      ${group.name}
                    </li>
                  `).join('')}
                  </ul><!-- /.list-group -->
                </div>
              </div>
            </div><!-- /.accordion-item-->
          </div><!-- /.accordion-->
          <div class="mt-3">
          <img src=${bannerImageUrl}> 
          </div>
        </div><!-- /.col-md-3 -->
        <div class="col-md-9">
          <div class="row">
          <div id="allProductsContainer">
            <div class="row g-3">
            <!-- Your code to display all products in a 3x3 grid goes here -->
            ${groups.flatMap(group => group.products).map(product => `
            ${product.shopifyProductUrl !== null ? `
              <div class="col-lg-4">
                <div class="card">
                  <a href="/products/${product.shopifyProductUrl}" target="_blank"><img src="${product.imageUrl.includes("/thumb")? product.imageUrl.replace("/thumb", ""):(product.imageUrl || '')}" class="img-fluid rounded-start-2 view-image" alt="" data-image-url="${product.imageUrl.includes("/thumb")? product.imageUrl.replace("/thumb", ""):(product.imageUrl || '')}" class="card-img-top img-fluid" alt=""></a>
                  <div class="card-title"><a href="/products/${product.shopifyProductUrl}" target="_blank">${product.shopifyProductTitle?product.shopifyProductTitle: product.partNo}</a></div>
                  <div class="card-body bg-light">${product.partDesc}</div>
                  <ul class="list-group list-group-flush">
                   ${product.footnote?`<li class="list-group-item"><strong>Notes: ${product.footnote}</strong></li>`:``}
                    ${product.addOns && product.addOns.length > 0 ? `
                      <li class="list-group-item"><strong>Alternates:</strong></li>
                      ${product.addOns.map(addOn => `
                        ${addOn.shopifyProductUrl !== null ? `
                          <li class="list-group-item d-flex">
                            <div class="col-3"><a href="/products/${addOn.shopifyProductUrl}" target="_blank"><img src="${addOn.imageUrl || ''}" width="50" height="50" alt=""></a></div>
                            <div class="col-9 flex mx-1"> <div> <a href="/products/${addOn.shopifyProductUrl}" target="_blank">${addOn.partNo} </a> </div> <div>  ${product.shopifyProductTitle.split(product.partNo)[1].trim()} </div></div>
                          </li>
                        ` : ''}
                      `).join('')}
                    ` : ''}
                  </ul>
                </div>
              </div>
            ` : ''}
          `).join('')} 
          </div>      
          </div>
            ${groups.map(group => `
              <div id="groupContainer${group.id}">
              <div class="row g-3">
              ${group.products.map(product => `
              ${product.shopifyProductUrl !== null ? `
                <div class="col-lg-4">
                  <div class="card">
                    <a href="/products/${product.shopifyProductUrl}" target="_blank"><img src="${product.imageUrl.includes("/thumb")? product.imageUrl.replace("/thumb", ""):(product.imageUrl || '')}" class="img-fluid rounded-start-2 view-image" alt="" data-image-url="${product.imageUrl.includes("/thumb")? product.imageUrl.replace("/thumb", ""):(product.imageUrl || '')}" class="card-img-top img-fluid" alt=""></a>
                    <div class="card-title"><a href="/products/${product.shopifyProductUrl}" target="_blank">${product.shopifyProductTitle?product.shopifyProductTitle: product.partNo}</a></div>
                    <div class="card-body bg-light">${product.partDesc}</div>
                    <ul class="list-group list-group-flush">
                     ${product.footnote?`<li class="list-group-item"><strong>Notes: ${product.footnote}</strong></li>`:``}
                      ${product.addOns && product.addOns.length > 0 ? `
                        <li class="list-group-item"><strong>Alternates:</strong></li>
                        ${product.addOns.map(addOn => `
                          ${addOn.shopifyProductUrl !== null ? `
                            <li class="list-group-item d-flex">
                              <div class="col-3"><a href="/products/${addOn.shopifyProductUrl}" target="_blank"><img src="${addOn.imageUrl || ''}" width="50" height="50" alt=""></a></div>
                              <div class="col-9 flex mx-1"> <div> <a href="/products/${addOn.shopifyProductUrl}" target="_blank" >${addOn.partNo} </a> </div> <div>  ${product.shopifyProductTitle.split(product.partNo)[1].trim()} </div></div>
                              </li>
                          ` : ''}
                        `).join('')}
                      ` : ''}
                    </ul>
                  </div>
                </div>
              ` : ''}
            `).join('')}        
              </div>
              </div>
            `).join('')}
           
          </div>
        </div>    
      </div>`}
    </div>
    `;
const resultsContainer = document.getElementById(resultContainer);
resultsContainer.innerHTML =""
    // Update the results container HTML content
    resultsContainer.innerHTML = htmlContent;
  }

 // Function to handle initial checkbox state and show/hide related group products
 function initializeCheckboxes() {
  const checkboxes = document.querySelectorAll('input[type="checkbox"]:not(#chkAll)');

  checkboxes.forEach(checkbox => {
    const groupId = checkbox.id.replace('chk', '');
    checkbox.checked = groupId === 'All'; // Check the "All" checkbox initially, uncheck others
    toggleVisibility(groupId);
  });
}
// Function to toggle visibility based on checkbox state
function toggleVisibility(groupId, isChecked) {

  const groupContainer = groupId === "All" ? document.getElementById("allProductsContainer") : document.getElementById('groupContainer' + groupId);

  if (groupContainer) {
    isChecked ? groupContainer.classList.remove("d-none") : groupContainer.classList.add("d-none");
  }
}
document.addEventListener('DOMContentLoaded', function () {
  var modelDropdown = document.getElementById('model');
  var submodelDropdown = document.getElementById('submodel');
  var makeDropdown = document.getElementById('make');
  var yearDropdown = document.getElementById('year');
  var seriesDropdown = document.getElementById('series');
  var engineDropdown = document.getElementById('engine');
  var vehicleDropdown = document.getElementById('vehicle');
  const resultsContainer = document.getElementById('resultsContainer');
  resultsContainer.innerHTML = '';
  var vehicleDetails = {};
  var jsonData = {}
  var baseEndPoint = "acsautoapi.azurewebsites.net";
  //  var baseEndPoint = "localhost:44370";

  document.getElementById('vresetId').addEventListener('click', function ()  {
    // Reset dropdowns to their initial state
    document.getElementById('make').selectedIndex = 0;
    //document.getElementById('model').selectedIndex = 0;
    // document.getElementById('yearDropdown').selectedIndex = 0;
    // document.getElementById('seriesDropdown').selectedIndex = 0;
    // Add more dropdowns as needed
    populateDropdown(submodelDropdown, null);
    populateDropdown(modelDropdown, null);
    populateDropdown(yearDropdown, null);
    populateDropdown(seriesDropdown, null);
    populateDropdown(engineDropdown, null);
    populateDropdown(vehicleDropdown, null);
    // Optionally, clear the results container
    const resultsContainer = document.getElementById('resultsContainer');
    resultsContainer.innerHTML = '';
})

  // Function to get the value of a cookie by name
  function getCookieValue(cookieName) {

    const cookieString = document.cookie;
    const cookies = cookieString.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === cookieName) {
        return value != "undefined" ? value : null;
      }
    }
    return null;
  }
  async function fetchData(url) {
    try {
      const response = await fetch(url, {
        headers: {
          'xuserid': getCookieValue('xuserid')
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const responseData = await response.json();

      // Set the 'xuserid' cookie with the value from the response
      document.cookie = `xuserid=${responseData.xuserid}; path=/`;

      // Access other data from the response
      const model = typeof responseData.model === "undefined" ? { groups: responseData.groups, vehicleDetails: responseData.vehicleDetails } : responseData.model;
    
      return model;
    } catch (error) {
      console.error('Error fetching data:', error);
      return null;
    }
  }


  // Function to populate a dropdown with options
  function populateDropdown(dropdown, options) {

    dropdown.value = ""

    if ((dropdown.id === "year" || dropdown.id === "series" || dropdown.id === "engine" || dropdown.id === "submodel" || dropdown.id === "vehicle") && options)
      dropdown.innerHTML = '<option value="">- Select -</option>'; // Clear previous options
    
    if (options) {
      if(dropdown.id === "submodel"){
        var optionElement = document.createElement('option');
        optionElement.value = "All";
        optionElement.text = "All";
        dropdown.add(optionElement);
        options.forEach(option => {
          if(option){
            const optionElement = document.createElement('option');
            optionElement.value = option;
            optionElement.text = option;
           
            dropdown.add(optionElement);
          }
         
        });
      }
      else{
        options.forEach(option => {
          var optionElement = document.createElement('option');
          optionElement.value = option;
          optionElement.text = option;
          if (option.includes("Popular Makes") || option.includes("Popular") || option.includes("All Models")) {
            optionElement.disabled = true;
            optionElement.selected = true;
            }
          dropdown.add(optionElement);
        });

        if (options.length === 1) {
          dropdown.value = options[0];
          dropdown.dispatchEvent(new Event('change'));
        }
      }
      
      dropdown.disabled = false; // Enable the dropdown
      
    } else {
      dropdown.innerHTML = '';
      dropdown.disabled = true; // Disable the dropdown
    }
  }

  // Populate the "Make" dropdown from the API
  // var makeDropdown = document.getElementById('make');
  fetchData(`https://${baseEndPoint}/AutoInfoSearch/GetPartsGuide?ReturnField=Make&PA=true`)
    .then(data => {
      if (data) {
        // Clear existing options
        // makeDropdown.innerHTML = '<option value="- Popular Makes -">- Popular Makes -</option>';

        // Populate options dynamically
        data.options.forEach(make => {
          const option = document.createElement('option');
          option.value = make;
          option.textContent = make;
          makeDropdown.appendChild(option);
        });
      }
    })
    .catch(error => console.error('Error fetching data:', error)).finally(() => {
      populateDropdown(submodelDropdown, null);
      populateDropdown(modelDropdown, null);
      populateDropdown(yearDropdown, null);
      populateDropdown(seriesDropdown, null);
      populateDropdown(engineDropdown, null);
      populateDropdown(vehicleDropdown, null);
    });
  // Add event listener to the "Make" dropdown
  // var makeDropdown = document.getElementById('make');
  makeDropdown.addEventListener('change', function () {
    var selectedMake = makeDropdown.value;

    // Reset other dropdowns

    populateDropdown(submodelDropdown, null);
    populateDropdown(modelDropdown, null);
    populateDropdown(yearDropdown, null);
    populateDropdown(seriesDropdown, null);
    populateDropdown(engineDropdown, null);
    populateDropdown(vehicleDropdown, null);

    // Show spinner while fetching data
    var spinner = document.getElementById('loadingSpinner');
    spinner.style.display = 'inline-block';

    if (selectedMake) {
      // Fetch and populate the "Model" dropdown
      fetchData(`https://${baseEndPoint}/AutoInfoSearch/GetPartsGuide?ReturnField=Model&make=${selectedMake}&PA=true`)
        .then(models => populateDropdown(modelDropdown, models.options))
        .finally(() => spinner.style.display = 'none');
    }
  });

  // Add event listener to the "Model" dropdown
  // var modelDropdown = document.getElementById('model');
  modelDropdown.addEventListener('change', function () {
    // var makeDropdown = document.getElementById('make');
    selectedMake = makeDropdown.value;
    var selectedModel = modelDropdown.value;
    populateDropdown(submodelDropdown, null);
    populateDropdown(yearDropdown, null);
    populateDropdown(seriesDropdown, null);
    populateDropdown(engineDropdown, null);
    populateDropdown(vehicleDropdown, null);

    if (selectedModel) {
      var spinner = document.getElementById('loadingSpinner');
      spinner.style.display = 'inline-block';
      // Fetch and populate the "Year" dropdown
      fetchData(`https://${baseEndPoint}/AutoInfoSearch/GetPartsGuide?ReturnField=series&make=${selectedMake.trim()}&model=${selectedModel.trim()}&PA=true`)
        .then(submodel => populateDropdown(seriesDropdown, submodel.options))
        .finally(() => spinner.style.display = 'none');
    }
  });


  submodelDropdown.addEventListener('change', function () {
    // var makeDropdown = document.getElementById('make');
    selectedMake = makeDropdown.value;
    var selectedModel = modelDropdown.value;
    var selectedSubModel = submodelDropdown.value;
    var selectedYear = yearDropdown.value;
    var selectedSubModel = submodelDropdown.value;
    var selectedSeries = seriesDropdown.value;

    //populateDropdown(yearDropdown, null);
   // populateDropdown(seriesDropdown, null);
    populateDropdown(engineDropdown, null);
    populateDropdown(vehicleDropdown, null);

    if (selectedModel) {

      var spinner = document.getElementById('loadingSpinner');
      spinner.style.display = 'inline-block';
      let url = `https://${baseEndPoint}/AutoInfoSearch/GetPartsGuide?ReturnField=engine&make=${selectedMake.trim()}`;

      // Add model to the URL only if submodelDropdown.value is not "All"
      if (selectedSubModel.trim() !== "All") {
          url += `&model=${selectedModel.trim()} : ${selectedSubModel.trim()}`;
      } else {
          url += `&model=${selectedModel.trim()}`;
      }
  
      // Add PA parameter
      url += `&series=${selectedSeries.trim()}&year=${selectedYear.trim()}&PA=true`;
      // Fetch and populate the "Year" dropdown
      fetchData(url)
        .then(engines => populateDropdown(engineDropdown, engines.options))
        .finally(() => spinner.style.display = 'none');
    }
  });


  yearDropdown.addEventListener('change', function () {
    var selectedYear = yearDropdown.value;

    var selectedMake = makeDropdown.value;
    var selectedModel = modelDropdown.value;
    var selectedSubModel = submodelDropdown.value;
    var selectedSeries = seriesDropdown.value;

    populateDropdown(submodelDropdown, null);
    populateDropdown(engineDropdown, null);
    populateDropdown(vehicleDropdown, null);

    if (selectedYear) {
      var spinner = document.getElementById('loadingSpinner');
      spinner.style.display = 'inline-block';

      let url = `https://${baseEndPoint}/AutoInfoSearch/GetPartsGuide?ReturnField=submodel&make=${selectedMake.trim()}`;

      // Add model to the URL only if submodelDropdown.value is not "All"
      if (selectedSubModel.trim() !== "All") {
          url += `&model=${selectedModel.trim()}`;
      } else {
          url += `&model=${selectedModel.trim()}`;
      }
  
      // Add year and PA parameter
      url += `&series=${selectedSeries.trim()}&year=${selectedYear.trim()}&PA=true`;

      // Fetch and populate the "Series" dropdown
      fetchData(url)
        .then(submodel => populateDropdown(submodelDropdown, submodel.options))
        .finally(() => spinner.style.display = 'none');
    }
  });

  // Add event listener to the "Series" dropdown

  seriesDropdown.addEventListener('change', function () {

    var selectedMake = makeDropdown.value;
    var selectedModel = modelDropdown.value;
    var selectedYear = yearDropdown.value;
    var selectedSubModel = submodelDropdown.value;
    var selectedSeries = seriesDropdown.value;

    populateDropdown(yearDropdown, null);
    populateDropdown(vehicleDropdown, null);
    populateDropdown(submodelDropdown, null);
    populateDropdown(engineDropdown, null);

    if (selectedSeries) {
      var spinner = document.getElementById('loadingSpinner');
      spinner.style.display = 'inline-block';
       // Base URL
    let url = `https://${baseEndPoint}/AutoInfoSearch/GetPartsGuide?ReturnField=year&make=${selectedMake.trim()}`;

    // Add model to the URL only if selectedSubModel is not "All"
    if (selectedSubModel.trim() !== "All") {
        url += `&model=${selectedModel.trim()}`;
    } else {
        url += `&model=${selectedModel.trim()}`;
    }

    // Add year and series parameters
    url += `&series=${selectedSeries.trim()}&PA=true`;
      // Fetch and populate the "Engine" dropdown
      fetchData(url)
        .then(engines => populateDropdown(yearDropdown, engines.options))
        .finally(() => spinner.style.display = 'none');
    }
  });

  // Add event listener to the "Engine" dropdown
  // var engineDropdown = document.getElementById('engine');
  engineDropdown.addEventListener('change', function () {
    var selectedMake = makeDropdown.value;
    var selectedModel = modelDropdown.value;
    var selectedYear = yearDropdown.value;
    var selectedSeries = seriesDropdown.value;
    var selectedSubModel = submodelDropdown.value;
    var selectedEngine = engineDropdown.value;

    // Reset other dropdowns
    // var vehicleDropdown = document.getElementById('vehicle');
    populateDropdown(vehicleDropdown, null);

    if (selectedEngine) {
      var spinner = document.getElementById('loadingSpinner');
      spinner.style.display = 'inline-block';

        // Base URL
    let url = `https://${baseEndPoint}/AutoInfoSearch/GetPartsGuide?ReturnField=Details&make=${selectedMake.trim()}`;

    // Add model to the URL only if selectedSubModel is not "All"
    if (selectedSubModel.trim() !== "All") {
        url += `&model=${selectedModel.trim()} : ${selectedSubModel.trim()}`;
    } else {
        url += `&model=${selectedModel.trim()}`;
    }

    // Add year, series, and engine parameters
    url += `&year=${selectedYear.trim()}&series=${selectedSeries.trim()}&engine=${selectedEngine.trim()}&PA=true`;

      // Fetch and populate the "Vehicle" dropdown
      fetchData(url)
        .then(vehicles => { populateDropdown(vehicleDropdown, vehicles.options); vehicleDetails = vehicles.details })
        .finally(() => spinner.style.display = 'none');
    }
  });


 


  document.getElementById('resultsContainer').addEventListener('change', function (event) {
    const target = event.target;
    if (event.target.id === 'chkAll') {
      // If "All" checkbox is checked, uncheck other checkboxes and show all products
      toggleVisibility('All', target.checked);
      const checkboxes = document.querySelectorAll('input[type="checkbox"]:not(#chkAll)');

      checkboxes.forEach(checkbox => {
        const groupId = checkbox.id.replace('chk', '');
        checkbox.checked = false; // Check the "All" checkbox initially, uncheck others
        toggleVisibility(groupId);
      });
    } else if (target.matches('input[type="checkbox"]')) {
      // If any other checkbox is checked, uncheck "All" checkbox and show/hide products based on the checkbox state
      document.getElementById('chkAll').checked = false;
      toggleVisibility('All', false);
      const groupId = target.id.replace('chk', '');
      toggleVisibility(groupId, target.checked);
    }
  });

 

  //   // Function to show/hide all products based on "All" checkbox state
  //   function toggleAllCheckboxes(isChecked) {
  //     const allProductsContainer = document.getElementById('allProductsContainer');
  //     allProductsContainer.style.display = isChecked ? 'block' : 'none';

  //     const allProducts = document.querySelectorAll('.product-catalog');
  //     allProducts.forEach(product => {
  //       product.style.display = isChecked ? 'block' : 'none';
  //     });

  //     // Reset other checkboxes to unchecked state
  //     const checkboxes = document.querySelectorAll('input[type="checkbox"]:not(#chkAll)');
  //     checkboxes.forEach(checkbox => {
  //       checkbox.checked = false;
  //     });
  //   }

  // // Event listener for checkbox changes
  // resultsContainer.addEventListener('change', function (event) {
  //   const target = event.target;
  //   if (target.id === 'chkAll') {
  //     toggleAllCheckboxes('All');
  //   } else if (target.matches('input[type="checkbox"]')) {
  //     const groupId = target.id.replace('chk', '');
  //     toggleVisibility(groupId);
  //   }
  // });
  // Add an event listener to the "Search" button
  document.getElementById('vehicleSearch').addEventListener('click', function () {
    var vehicleDropdown = document.getElementById('vehicle');
    var spinner = document.getElementById('loadingSpinner');
    var selectedVehicle = vehicleDropdown.value;
    // var xuserid = getCookieValue('xuserid');

    // const headers = {
    //   'xuserid': xuserid,
    //   // Add other headers if needed
    // };

    //console.log("vehicleDetails", vehicleDetails)
    selectedVehicleDetails = vehicleDetails.find(vehicle => vehicle.option === selectedVehicle);
    // Check if a vehicle is selected
    if (selectedVehicleDetails) {
      //console.log("vehicleId", selectedVehicleDetails)
      //var vehicleId = vehicleDetails[0].vehicleId;
      //if (vehicleId) {
      // Fetch data based on the vehicleId
      const apiUrl = `https://${baseEndPoint}/AutoInfoSearch/GetSearchResultsByKey?vehicleId=${selectedVehicleDetails.vehicleIdEncrypted}`;
      spinner.style.display = 'inline-block'; // Show the spinner before making the request

      fetchData(apiUrl)
        .then(data => {
         // console.log("result_data", data);
          if (data) {
            // Populate the page with fetched data
            populatePageWithData(data,'resultsContainer');
            // Show the result div
            document.getElementById('resultDiv').style.display = 'block';
            // Hide the no parts found message
            document.getElementById('noPartsFound').style.display = 'none';
          } else {
            // Show the no parts found message
            document.getElementById('noPartsFound').style.display = 'block';
            // Hide the result div
            document.getElementById('resultDiv').style.display = 'none';
          }

        }).finally(() => {
          // Hide the spinner after data processing is complete (whether successful or not)
          spinner.style.display = 'none';
        });
      //}
      // Construct the URL with the selected vehicle ID
      // var resultPageUrl = `search-result.html?vehicleId=` + vehicleDetails[0].vehicleId;

      // Redirect to the result page
      // window.location.href = resultPageUrl;
    } else {
      // Handle the case where no vehicle is selected, e.g., show an alert
      alert('Please select a vehicle before searching.');
    }
    //initializeCheckboxes();
  });
  //initializeCheckboxes();
});

